import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import PropTypes from 'prop-types';

export const CompetitionModelCodesDropdown = ({
  competitionCompModelCodes,
  handleClick,
  onRef,
}) => (
  <div className={styles.dropdownStyle} ref={onRef}>
    {competitionCompModelCodes.map(compModel => (
      <button
        className={styles.competitionSelection}
        key={compModel.desc}
        onClick={handleClick(compModel.code)}
      >
        {compModel.desc}
      </button>
    ))}
  </div>
);

CompetitionModelCodesDropdown.propTypes = {
  competitionCompModelCodes: PropTypes.array.isRequired,
  onRef: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default enhance(CompetitionModelCodesDropdown);
